<template>
  <div class="income-detail-container">
    <van-nav-bar
      :title="$t('host_earnings Details')"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
      <van-empty v-if="incomeList.length == 0" :description="$t('no data')" />
      <div class="income-list">
        <div class="income-list-item" v-for="item in incomeList" :key="item.id">
          <div class="income-list-item-col">
            <div class="col-top">{{ $t('time') }}</div>
            <div class="col-bot">
              {{ (item.created_at * 1000) | dateFormat("MM/dd/yyyy hh:mm:ss") }}
            </div>
          </div>
          <div class="income-list-item-col">
            <div class="col-top">{{ $t('host_income') }}</div>
            <div class="col-bot income">{{ item.income }} ETH</div>
          </div>
          <div class="income-list-item-col">
            <div class="col-top">{{ $t('host_account Balance') }}</div>
            <div class="col-bot">{{ item.money }}</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      lastPage: 1,
      isLoading: false,
      incomeList: [],
    };
  },
  created() {
    this.getIncomeList();
  },
  mounted() {
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.getIncomeList();
      }, 1000);
    },
    async getIncomeList() {
      const res = await this.$api.getIncomeList({ page: this.page });
      if (res.code == 200) {
        this.lastPage = res.data.last_page;
        if (this.page == 1) {
          this.incomeList = res.data.data;
        } else {
          this.incomeList.push(...res.data.data);
        }
      }
    },
    navBack() {
      this.$router.replace('/');
    },
    async scroll() {
      let scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.page < this.lastPage) {
        if (scrollHeight - scroll <= 830) {
          this.page++;
          this.getIncomeList();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.income-detail-container {
  .income-list {
    background: #fff;
    margin-top: 10px;
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 10px;
      border-bottom: 1px solid #eee;
      &-col {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        &:first-child {
          align-items: flex-start;
        }
        &:last-child {
          align-items: flex-end;
        }
        .col-top {
          font-size: 12px;
          color: #5a6e81;
        }
        .col-bot {
          font-size: 14px;
          font-weight: bold;
          margin-top: 10px;
        }
        .income {
          color: #55a484;
        }
      }
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    height: 100px;
    left: unset;
  }
  /deep/ .van-tabs__wrap {
    height: 50px;
  }
  .back {
    width: 30px;
    height: 15px;
  }
  .income-detail-container {
    .income-list {
      background: #fff;
      margin-top: 10px;
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 10px;
        border-bottom: 1px solid #eee;
        &-col {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          &:first-child {
            align-items: flex-start;
          }
          &:last-child {
            align-items: flex-end;
          }
          .col-top {
            font-size: 12px;
            color: #5a6e81;
          }
          .col-bot {
            font-size: 14px;
            font-weight: bold;
            margin-top: 10px;
          }
          .income {
            color: #55a484;
          }
        }
      }
    }
  }
}
</style>